<template>
	<div class="page-mdl">
		
	</div>
</template>

<script>
export default {
	name: 'index',
	data () {
		return {
			
		}
	},
	
	created(){
		
	},
  
	computed:{
		
	},
  
	methods:{
		
	}
}
</script>

<style lang="less" scoped>

</style>



// WEBPACK FOOTER //
// src/pages/teacher-list/tpl-mobile.vue